import { BaseResponse } from '../base-response';
import { Any, JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";

@JsonConverter
export class PasspointDeviceAccountDataConverter implements JsonCustomConvert<PasspointDeviceAccount> {
	serialize() { }
	deserialize(data: any): PasspointDeviceAccount {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, PasspointDeviceAccount);
	}
}

@JsonObject("PasspointDeviceAccount")
export class PasspointDeviceAccount {
	@JsonProperty("identity_email", String, true)
	identity_email: string = "";
	@JsonProperty("username", String, true)
	username: string = "";
	@JsonProperty("status", String, true)
	status: string = "";
	@JsonProperty("created_at", Any, true)
	created_at: any = null;
	@JsonProperty("last_login", Any, true)
	last_login: any = null;
	@JsonProperty("valid_since", Any, true)
	valid_since: any = null;
	@JsonProperty("valid_until", Any, true)
	valid_until: any = null;
	@JsonProperty("os_version", String, true)
	os_version: string = "";
	@JsonProperty("channel", String, true)
	channel: string = "";
	@JsonProperty("passpoint_service", String, true)
	passpoint_service: string = "";
}

@JsonObject("PasspointDeviceAccountData")
export class PasspointDeviceAccountData extends BaseResponse {
	@JsonProperty("data", PasspointDeviceAccountDataConverter, true)
	data: PasspointDeviceAccount = new PasspointDeviceAccount();
}